import * as React from 'react'
import { useState } from 'react'
import { Button, Alert } from 'react-bootstrap'
import TrueNativeEditorModal from './TrueNativeEditor/TrueNativeEditorModal'

interface Props {
	campaignId?: number
}

const TrueNativeArticles = ({ campaignId }: Props) => {
	const [showModal, setShowModal] = useState(false)

	// Feature flag check - same pattern as campaign creation
	const urlParams = new URLSearchParams(window.location.search)
	const showTrueNative = urlParams.get('showtruenative') === '1'

	// If feature flag is not enabled, this component shouldn't render
	if (!showTrueNative) {
		return null
	}

	const handleOpenTrueNativeEditor = () => {
		setShowModal(true)
	}

	const handleCloseModal = () => {
		setShowModal(false)
	}

	return (
		<div className="true-native-articles">
			<Alert bsStyle="info">
				<h4>True Native Content Creation</h4>
				<p>
					True Native campaigns use a specialized editor to create landing pages that match the
					publisher&apos;s site design and feel like native content. Click the button below to open the True
					Native editor where you can design your campaign content.
				</p>
				<hr />
				<div style={{ textAlign: 'right' }}>
					<Button bsStyle="primary" bsSize="large" onClick={handleOpenTrueNativeEditor}>
						Open True Native Editor
					</Button>
				</div>
			</Alert>

			<TrueNativeEditorModal show={showModal} onClose={handleCloseModal} campaignId={campaignId} />
		</div>
	)
}

export default TrueNativeArticles
